import * as React from 'react'
import 'react-loading-skeleton/dist/skeleton.css'
import { BrowserRouter, Route, Switch } from 'react-router-dom'

import { GlobalStyle } from 'styles/global-styles'
import { View } from '../styles/reactnative'
import Logout from './components/Logout'
import { NotFoundPage } from './components/NotFoundPage/Loadable'
import { useToken } from './hooks'
import { PrivacyPolicyPage } from './pages/ASecondaryPages/PrivacyPolicyPage'
import { LoginPage } from './pages/AuthenticationPages/LoginPage/Loadable'
import { SignUpPage } from './pages/AuthenticationPages/SignUpPage/Loadable'
import { HomePage } from './pages/HomePage/Loadable'
import { NotificationPage } from './pages/NotificationPage/Loadable'
import { OrderBookView } from './pages/OrderBook'
import { OrdersPage } from './pages/OrdersPage/Loadable'
import { PositionView } from './pages/PostionView'
import { ProfileSettingPage } from './pages/ProfileSetting/Loadable'
import { TradePage } from './pages/TradePage/Loadable'
import { ZMobileTradingView } from './pages/ZMobileTradingView/Loadable'

export function Routes() {
	// const { t, i18n } = useTranslation()
	// const realDevice = /iphone|ipad|ipod|android|mobile/i.test(
	// 	navigator.userAgent?.toLowerCase()
	// )
	// const { isMobile } = React.useContext(ThemeContext)
	// const { width } = useWindowDimensions()

	const { data: token } = useToken()
	var useragt = navigator.userAgent.toLowerCase()
	if (useragt.match(/kakaotalk/i)) {
		return (
			<View
				style={{
					flex: 1,
					justifyContent: 'center',
					alignItems: 'center',
					height: '100%',
					fontSize: 20,
				}}>
				카카오톡 외부브라우저에서 접속해주세요.
			</View>
		)
	}
	return (
		<BrowserRouter>
			<Switch>
				<Route
					exact
					path="/trade/chart"
					component={ZMobileTradingView}
				/>
				<Route
					exact
					path="/trade/chart/*"
					component={ZMobileTradingView}
				/>
				<Route
					exact
					path="/settings"
					component={token ? ProfileSettingPage : LoginPage}
				/>
				<Route
					exact
					path="/settings/*"
					component={token ? ProfileSettingPage : LoginPage}
				/>
				<Route
					exact
					path="/partner"
					component={() => {
						const hostname = window.location.hostname;
						const parts = hostname.split('.');
						let partnerDomain: string;
						if (parts.length >= 3) {
							// web.lancer-asset.com -> partner.lancer-asset.com
							parts[0] = 'partner';
							partnerDomain = parts.join('.');
						} else {
							// lancerasset.com -> partner.lancerasset.com
							partnerDomain = 'partner.' + hostname;
						}
						window.location.href = `https://${partnerDomain}?ssotoken=${token}`;
						return null
					}}
				/>
				<Route
					exact
					path="/"
					component={token ? HomePage : LoginPage}
				/>
				{/* Authentication Page */}
				<Route
					exact
					path="/login/"
					component={token ? HomePage : LoginPage}
				/>

				<Route exact path="/logout" component={Logout} />

				<Route exact path="/trade/positions" component={PositionView} />
				<Route
					exact
					path="/trade/positions/*"
					component={PositionView}
				/>
				<Route
					exact
					path="/trade/orderbook"
					component={OrderBookView}
				/>
				<Route
					exact
					path="/trade/orderbook/*"
					component={OrderBookView}
				/>
				<Route
					exact
					path="/signup/"
					component={token ? HomePage : SignUpPage}
				/>
				{/* Authentication Page */}

				<Route
					exact
					path="/notifications/"
					component={NotificationPage}
				/>


				{/* Trading View Page */}
				<Route
					exact
					path="/trade/"
					component={!token ? LoginPage : TradePage}
				/>
				<Route
					exact
					path="/trade/*"
					component={!token ? LoginPage : TradePage}
				/>
				{/* Trading View Page */}

				{/* Markets  Page */}

				<Route
					exact
					path="/assets"
					component={!token ? LoginPage : HomePage}
				/>

				{/* Orders Page */}
				<Route
					exact
					path="/orders"
					component={!token ? LoginPage : OrdersPage}
				/>

				<Route
					exact
					path="/terms-service/"
					component={PrivacyPolicyPage}
				/>
				<Route path="*" component={NotFoundPage} />
			</Switch>

			<GlobalStyle />
		</BrowserRouter>
	)
}
